import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api/client";

const TYP_ROUTE = {
  sitzung: id => `/sitzungen/${id}`,
  vorlage: id => `/vorlagen/${id}`,
  gremium: id => `/gremien`,
  beschluss: id => `/beschluesse`,
};
const TYP_LABEL = { sitzung: "Sitzung", vorlage: "Vorlage", gremium: "Gremium", beschluss: "Beschluss" };

export default function Suche() {
  const [query, setQuery] = useState("");
  const [ergebnisse, setErgebnisse] = useState(null);
  const [offen, setOffen] = useState(false);
  const timeout = useRef(null);
  const ref = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOffen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const onChange = (val) => {
    setQuery(val);
    clearTimeout(timeout.current);
    if (val.trim().length < 2) {
      setErgebnisse(null);
      setOffen(false);
      return;
    }
    timeout.current = setTimeout(() => {
      api.suche(val.trim()).then(r => { setErgebnisse(r); setOffen(true); }).catch(() => {});
    }, 300);
  };

  const klick = (e) => {
    const route = TYP_ROUTE[e.typ];
    if (route) navigate(route(e.id));
    setOffen(false);
    setQuery("");
    setErgebnisse(null);
  };

  return (
    <div ref={ref} style={{ position: "relative", padding: "0 20px 12px" }}>
      <input
        type="text"
        placeholder="Suchen…"
        value={query}
        onChange={e => onChange(e.target.value)}
        onFocus={() => ergebnisse && setOffen(true)}
        style={{
          width: "100%", padding: "7px 10px", borderRadius: 6, border: "1px solid #444",
          background: "#222", color: "#eee", fontSize: 13, boxSizing: "border-box",
        }}
      />
      {offen && ergebnisse && (
        <div style={{
          position: "absolute", top: "100%", left: 20, right: 20, marginTop: 4,
          background: "#fff", borderRadius: 8, boxShadow: "0 4px 16px rgba(0,0,0,0.25)",
          zIndex: 100, color: "#333", maxHeight: 320, overflowY: "auto",
        }}>
          {ergebnisse.length === 0 && (
            <div style={{ padding: 14, fontSize: 12, color: "#999" }}>Keine Treffer.</div>
          )}
          {ergebnisse.map((e, i) => (
            <div key={i} onClick={() => klick(e)} style={{
              padding: "10px 14px", cursor: "pointer", borderBottom: "1px solid #f5f5f5", fontSize: 13,
            }}>
              <span style={{ fontSize: 10, color: "#999", textTransform: "uppercase", marginRight: 6 }}>
                {TYP_LABEL[e.typ] || e.typ}
              </span>
              {e.titel}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
